module.exports = __webpack_public_path__ + "static/media/logo_sottositi_2025.5e558525.png";